import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';

@Component({
  selector: 'app-side-virtualclass',
  templateUrl: './side-virtualclass.component.html',
  styleUrls: ['./side-virtualclass.component.scss']
})
export class SideVirtualclassComponent {
  constructor(
    private elRef:ElementRef,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private sharedService: SharedService
    ) {}
  @Input() userInfos:  { [x:string]: any } = new Map();
  virtualClassPages = [{id_page: 'vcl-content-project', name: 'Edit Content', 'icon': 'edit_document', group: 'content'}, {id_page: 'vcl-create-project', name: 'Create Project', icon: 'add_notes', group: 'content'}, {id_page: 'vcl-upload-content', name: 'Upload Content', icon: 'upload', group: 'content'},
    {id_page: 'vcl-student-dashboard', name: 'Dashboard', icon: 'groups', group: 'admin'}, {id_page: 'vcl-student-manager', name: 'Student Manager', icon: 'manage_accounts', group: 'admin'},
     {id_page: 'vcl-manage-ressource', name: 'Manage Ressource', icon: 'school', group: 'admin'},
    {id_page: 'vcl-promotion', name: 'Promotion', 'icon': 'thumb_up_off_alt', group: 'admin'}, {id_page: 'vcl-advertisment', name: 'Advertisment', 'icon': 'campaign', group: 'admin'},
  ];
  contentMenus:{ [x:string]: any }[] = [];
  adminMenus:{ [x:string]: any }[] = [];
  activePage = 'vcl-content-project';
  ngOnInit(){
    let authorizations = this.userInfos?.['authorization']?.virtualclass || [];
    this.virtualClassPages = authorizations.length? this.virtualClassPages.filter((item:any)=> authorizations.includes(item.id_page)): [];
    this.activePage = this.userInfos?.['navigation_infos']?.['vcl_last_page'] || this.activePage;
    this.contentMenus = this.virtualClassPages.filter((item:any)=> item.group == 'content');
    this.adminMenus = this.virtualClassPages.filter((item:any)=> item.group == 'admin');
  }
  
  showHidePage(pageId:string){
    this.activePage = pageId;
    this.sharedService.sendData({side_class_page_id: pageId, close_side_nav: true});

  }
}
